import { ReactComponent as ToastBell } from '../assets/svg/toastBell.svg';
import toast from 'react-hot-toast';
export const truncate = (text, startNum = 0, endNum) => {
	if (text.length > endNum) {
		return {
			text: text.substring(startNum, endNum).concat('...'),
			isTruncated: true,
		};
	} else {
		return { text: text, isTruncated: false };
	}
};
export const capitaliseFirstLetter = (word = '') => {
	return word?.charAt(0).toUpperCase() + word?.slice(1);
};
export const notify = (message, color = '#fddf6d') => {
	// toast.info(message, {
	//     position: toast.POSITION.TOP_CENTER,
	//     style: { backgroundColor: color, color: "#5e639b" },
	//     autoClose: 3000,
	//     hideProgressBar: false,
	//     icon: <></>,
	//     progressStyle: { backgroundColor: "#5e639b" },
	// });

	toast.custom((t) => {
		return (
			<div
				className={`${t.visible ? 'animate-enter' : 'animate-leave'} max-w-md p-4 w-full rounded-xl pointer-events-auto flex`}
				style={{ background: 'linear-gradient(51.22deg, #7B7AC7 6.44%, #8B89D6 83.74%)' }}
			>
				<div className='flex flex-row justify-between items-center'>
					<div className='mr-4 rounded-full w-[57px] min-w-[57px] h-[57px] flex items-center justify-center border border-brandYellow'>
						<ToastBell />
					</div>
					<div className='flex flex-col text-left'>
						<div className='text-brandYellow font-bold text-xl'>{message}</div>
						{/* <div>
							<span className='text-lightBG text-sm'>This popup will be auto closed in </span>
							<span id={`toast-${t.id}`} className='text-base font-bold text-highlightColor'>
								3
							</span>
						</div> */}
					</div>
				</div>
			</div>
		);
	});
};

export const checkAllowedExtensions = (name) => {
	if (
		name.toLowerCase().includes('.png') ||
		name.toLowerCase().includes('.jpg') ||
		// name.toLowerCase().includes('.gif') ||
		// name.toLowerCase().includes('.svg') ||
		name.toLowerCase().includes('.jpeg')
	)
		return true;
	else {
		return false;
	}
};
